export const resourcePasswordSelector = (resourceKey) => state => {
    if (!Boolean(resourceKey)) {
        return null;
    }

    return  state.resourcePasswords[resourceKey];
}